import { createContext } from "react";

export type Severity = 'info' | 'warning' | 'error' | 'critical';

export interface NotifyType {
	title: string
	severity: Severity;
	error: any;
}

export interface NotifyContextType {
	notify: NotifyType | null;
	setNotify: (notify: NotifyType | null) => void;
}

export const NotifyContext = createContext<NotifyContextType | undefined>(undefined);

